export enum NotificationMode {
  /** 永不 */
  Never = "0",
  /** 一次 */
  Once = "1",
  /** 持續 */
  Always = "2",
}
